module.exports = __webpack_public_path__ + "static/img/sfsy.5084a57.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo/sfsy.png
// module id = OKXF
// module chunks = 1